import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from '../Donate/CheckoutForm';

const stripePromise = loadStripe('pk_test_51MXK2rEdk4rkdxrRX5c2jRT76zPAU0ahM4bFl6UKh88qCb6nYGwsxWKi0umgckxI8CM8g1U7vt1OWKdqs4zmcFNP00TqLUahEq');

class Donate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAmount: null,
      customAmount: '',
      name: '',
      email: '',
      showCustomAmount: true
    };
  }

  handleAmountSelect = (amount) => {
    this.setState({ selectedAmount: amount, showCustomAmount: false });
  };

  handleCustomAmountChange = (e) => {
    this.setState({ customAmount: e.target.value, selectedAmount: null });
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    const { selectedAmount, customAmount, name, email, showCustomAmount } = this.state;
    const donationAmounts = [5, 10, 15, 20, 25, 30];

    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #eff6ff 0%, #ffffff 50%, #fff7ed 100%)',
        padding: 'clamp(1rem, 3vw, 1.5rem)',
        boxSizing: 'border-box'
      }}>
        <div style={{ 
          maxWidth: '1200px', 
          margin: '0 auto',
          padding: '0 clamp(0.5rem, 2vw, 1rem)'
        }}>
          {/* Hero Section */}
          <div style={{ textAlign: 'center', marginBottom: 'clamp(1.5rem, 4vw, 2rem)' }}>
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              padding: '0.5rem 1rem',
              borderRadius: '9999px',
              background: '#E8F8EE',
              color: '#237A4B',
              fontSize: '0.875rem',
              fontWeight: '500',
              marginBottom: '1rem'
            }}>
              <span style={{
                width: '0.5rem',
                height: '0.5rem',
                backgroundColor: '#2E8B54',
                borderRadius: '50%',
                marginRight: '0.5rem'
              }}></span>
              Make a Difference Today
            </div>
            <h1 style={{
              fontSize: 'clamp(1.5rem, 5vw, 2.5rem)',
              fontWeight: '700',
              color: '#111827',
              marginBottom: '0.75rem',
              lineHeight: '1.1'
            }}>
              Your{' '}
              <span style={{
                background: 'linear-gradient(to right, #2E8B54, #1B2B5C)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                Generosity
              </span>
              <br />
              Changes Lives
            </h1>
            <p style={{
              fontSize: 'clamp(0.875rem, 2.5vw, 1rem)',
              color: '#4b5563',
              maxWidth: '32rem',
              margin: '0 auto',
              lineHeight: '1.5'
            }}>
              Join us in our mission to support refugees and create positive change in communities. 
              Every donation, no matter the size, makes a real difference.
            </p>
          </div>

          {/* Main Donation Form */}
          <div style={{
            backgroundColor: 'white',
            borderRadius: 'clamp(1rem, 2vw, 1.25rem)',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            border: '1px solid #f3f4f6',
            padding: 'clamp(1.5rem, 4vw, 2rem)',
            marginBottom: '1.5rem'
          }}>
            <div style={{ textAlign: 'center', marginBottom: 'clamp(1rem, 3vw, 1.5rem)' }}>
              <h2 style={{
                fontSize: 'clamp(1.25rem, 3vw, 1.5rem)',
                fontWeight: '700',
                color: '#111827',
                marginBottom: '0.25rem'
              }}>Make Your Donation</h2>
              <p style={{ color: '#4b5563', fontSize: 'clamp(0.75rem, 2vw, 0.875rem)' }}>Every contribution helps us create positive change</p>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              {/* Personal Information and Donation Amount - Responsive Layout */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                gap: '2rem',
                alignItems: 'start'
              }}>
                {/* Left Column - Personal Information */}
                <div>
                  <h3 style={{
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: '#111827',
                    marginBottom: '0.75rem'
                  }}>Personal Information</h3>
                  
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                    <div>
                      <label style={{
                        display: 'block',
                        fontSize: '0.75rem',
                        fontWeight: '500',
                        color: '#374151',
                        marginBottom: '0.25rem'
                      }}>Full Name</label>
                      <input
                        type="text"
                        name="name"
                        value={name}
                        onChange={this.handleInputChange}
                        style={{
                          width: '100%',
                          padding: '0.625rem 0.75rem',
                          border: '1px solid #d1d5db',
                          borderRadius: '0.5rem',
                          fontSize: '0.875rem',
                          transition: 'all 0.2s ease',
                          boxSizing: 'border-box'
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#2E8B54';
                          e.target.style.boxShadow = '0 0 0 3px rgba(46, 139, 84, 0.1)';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#d1d5db';
                          e.target.style.boxShadow = 'none';
                        }}
                        placeholder="Enter your full name"
                        required
                      />
                    </div>
                    <div>
                      <label style={{
                        display: 'block',
                        fontSize: '0.75rem',
                        fontWeight: '500',
                        color: '#374151',
                        marginBottom: '0.25rem'
                      }}>Email Address</label>
                      <input
                        type="email"
                        name="email"
                        value={email}
                        onChange={this.handleInputChange}
                        style={{
                          width: '100%',
                          padding: '0.625rem 0.75rem',
                          border: '1px solid #d1d5db',
                          borderRadius: '0.5rem',
                          fontSize: '0.875rem',
                          transition: 'all 0.2s ease',
                          boxSizing: 'border-box'
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#2E8B54';
                          e.target.style.boxShadow = '0 0 0 3px rgba(46, 139, 84, 0.1)';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#d1d5db';
                          e.target.style.boxShadow = 'none';
                        }}
                        placeholder="Enter your email address"
                        required
                      />
                    </div>
                  </div>
                </div>

                {/* Right Column - Donation Amount */}
                <div>
                  <h3 style={{
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: '#111827',
                    marginBottom: '0.75rem'
                  }}>Select Donation Amount</h3>
                  
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(70px, 1fr))',
                    gap: '0.5rem',
                    marginBottom: '1rem'
                  }}>
                    {donationAmounts.map((amount) => (
                      <button
                        key={amount}
                        type="button"
                        onClick={() => this.handleAmountSelect(amount)}
                        style={{
                          padding: '0.5rem 0.25rem',
                          borderRadius: '0.5rem',
                          border: '2px solid',
                          fontWeight: '600',
                          fontSize: '0.75rem',
                          transition: 'all 0.2s ease',
                          cursor: 'pointer',
                          minHeight: '2.5rem',
                          ...(selectedAmount === amount
                            ? {
                                borderColor: '#2E8B54',
                                backgroundColor: '#2E8B54',
                                color: 'white',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                                transform: 'scale(1.02)'
                              }
                            : {
                                borderColor: '#e5e7eb',
                                color: '#374151',
                                backgroundColor: 'transparent'
                              }
                          )
                        }}
                        onMouseEnter={(e) => {
                          if (selectedAmount !== amount) {
                            e.target.style.borderColor = '#2E8B54';
                            e.target.style.backgroundColor = '#E8F8EE';
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (selectedAmount !== amount) {
                            e.target.style.borderColor = '#e5e7eb';
                            e.target.style.backgroundColor = 'transparent';
                          }
                        }}
                      >
                        ${amount}
                      </button>
                    ))}
                  </div>
                  
                  {/* Custom Amount */}
                  <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    gap: '0.5rem'
                  }}>
                    <button
                      type="button"
                      onClick={() => this.setState({ showCustomAmount: !showCustomAmount, selectedAmount: null })}
                      style={{
                        alignSelf: 'flex-start',
                        padding: '0.5rem 1rem',
                        borderRadius: '0.5rem',
                        border: '2px solid',
                        fontWeight: '500',
                        fontSize: '0.75rem',
                        transition: 'all 0.2s ease',
                        cursor: 'pointer',
                        ...(showCustomAmount
                          ? {
                              borderColor: '#2E8B54',
                              backgroundColor: '#2E8B54',
                              color: 'white'
                            }
                          : {
                              borderColor: '#e5e7eb',
                              color: '#374151',
                              backgroundColor: 'transparent'
                            }
                        )
                      }}
                      onMouseEnter={(e) => {
                        if (!showCustomAmount) {
                          e.target.style.borderColor = '#2E8B54';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!showCustomAmount) {
                          e.target.style.borderColor = '#e5e7eb';
                        }
                      }}
                    >
                      Custom Amount
                    </button>
                    {showCustomAmount && (
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.25rem'
                      }}>
                        <label style={{
                          fontSize: '0.75rem',
                          fontWeight: '500',
                          color: '#374151'
                        }}>Enter amount:</label>
                        <input
                          type="number"
                          value={customAmount}
                          onChange={this.handleCustomAmountChange}
                          style={{
                            width: '100%',
                            maxWidth: '150px',
                            padding: '0.5rem 0.75rem',
                            border: '1px solid #d1d5db',
                            borderRadius: '0.5rem',
                            fontSize: '0.875rem',
                            transition: 'all 0.2s ease'
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = '#2E8B54';
                            e.target.style.boxShadow = '0 0 0 3px rgba(46, 139, 84, 0.1)';
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = '#d1d5db';
                            e.target.style.boxShadow = 'none';
                          }}
                          placeholder="Enter amount"
                          min="1"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Stripe Payment Form */}
              <div style={{
                borderTop: '1px solid #e5e7eb',
                paddingTop: '1rem'
              }}>
                <h3 style={{
                  fontSize: 'clamp(0.875rem, 2.5vw, 1rem)',
                  fontWeight: '600',
                  color: '#111827',
                  marginBottom: '0.75rem'
                }}>Payment Information</h3>
                <div style={{
                  backgroundColor: '#f9fafb',
                  borderRadius: '0.5rem',
                  padding: 'clamp(0.75rem, 2vw, 1rem)',
                  border: '1px solid #e5e7eb',
                  overflow: 'hidden'
                }}>
                  <Elements stripe={stripePromise}>
                    <CheckoutForm 
                      selectedAmount={selectedAmount}
                      customAmount={customAmount}
                      name={name}
                      email={email}
                    />
                  </Elements>
                </div>
              </div>

              {/* Action Buttons */}
            </div>
          </div>

          {/* Bottom CTA */}
          <div style={{ textAlign: 'center' }}>
            <div style={{
              background: 'linear-gradient(135deg, #fff7ed, #eff6ff)',
              borderRadius: 'clamp(0.5rem, 2vw, 0.75rem)',
              padding: 'clamp(1rem, 3vw, 1.5rem)'
            }}>
              <h3 style={{
                fontSize: 'clamp(1rem, 3vw, 1.25rem)',
                fontWeight: '700',
                color: '#111827',
                marginBottom: '0.75rem'
              }}>Questions About Donating?</h3>
              <p style={{ color: '#4b5563', marginBottom: '1rem', fontSize: 'clamp(0.75rem, 2vw, 0.875rem)' }}>
                We're here to help you make the most impact with your donation
              </p>
              <Link
                to="/contact"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  padding: 'clamp(0.5rem, 2vw, 0.625rem) clamp(1rem, 3vw, 1.25rem)',
                  backgroundColor: 'white',
                  color: '#111827',
                  fontWeight: '600',
                  borderRadius: '0.5rem',
                  textDecoration: 'none',
                  transition: 'all 0.2s ease',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  fontSize: 'clamp(0.75rem, 2vw, 0.875rem)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f9fafb';
                  e.target.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'white';
                  e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
                }}
              >
                Contact Us
                <svg style={{ width: 'clamp(0.75rem, 2vw, 0.875rem)', height: 'clamp(0.75rem, 2vw, 0.875rem)', marginLeft: '0.5rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Donate;